export default __webpack_public_path__ + "static/media/ftj-5.3fc08745.jpeg";